import { render, staticRenderFns } from "./PromotionInternsForm.vue?vue&type=template&id=e2a9c516&scoped=true"
import script from "./PromotionInternsForm.vue?vue&type=script&lang=js"
export * from "./PromotionInternsForm.vue?vue&type=script&lang=js"
import style0 from "./PromotionInternsForm.vue?vue&type=style&index=0&id=e2a9c516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a9c516",
  null
  
)

export default component.exports